import React from "react";
import InvalidFeedback from "../InvalidFeedback";

export default React.forwardRef(({ label, errors, ...register }: any, ref) => {
    return (
        <>
            <div className="form-check form-switch ">
                <input type="checkbox" className="form-check-input" ref={ref} {...register} />
                <label className="form-check-label">{label}</label>
            </div>
            <InvalidFeedback error={errors} />
        </>
    )
})